import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { sessionToken } = useAuth(); // Get sessionToken from AuthContext

    return sessionToken ? <>{children}</> : <Navigate to="/auth" replace />;
};

export default ProtectedRoute;
